import React, { useState } from "react"
import { useQueryClient } from "@tanstack/react-query"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { AdminTransactionsService } from "services/api-service"
import { AdminTransactionType } from "services/api-service/types"
import { SentryService } from "services/SentryService"
import { Box } from "ui/components/atoms/_atoms"
import Button, { IconButton } from "ui/components/atoms/button"
import Input from "ui/components/atoms/input"
import Modal from "ui/components/molecules/modal"
import { WEBSITE_REGEX } from "ui/utils/regex"

const TransactionInvoiceButton = ({ data }: { data: AdminTransactionType }) => {
  const { t } = useTranslation(["form"])
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)

  const queryClient = useQueryClient()

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    setError,
    reset,
    unregister,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      url: data.invoiceUrl || "",
    },
  })

  const isDisabled = data.value === 0
  const isActive = isDisabled || !!data.invoiceUrl

  const onSubmit = async (el: { url: string }) => {
    try {
      setLoading(true)
      await AdminTransactionsService.addInvoiceUrl(data.id, el.url)
      queryClient.refetchQueries({ queryKey: ["transactions"] })
    } catch (e) {
      SentryService.error("[ERROR AdminTransactionsService.addInvoiceUrl]:", e)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {data.status === "paid" && (
        <IconButton
          $marginLeft="XS"
          icon="check"
          ariaLabel="Add invoice URL"
          $size="45px"
          $iconSize="M"
          $borderRadius="borderRadius"
          $borderColor={isActive ? "primary" : "border"}
          $background={isActive ? "primaryBackground" : "background"}
          $color={isActive ? "primary" : "second"}
          onClick={() => setShow(true)}
          disabled={isDisabled || data.status !== "paid"}
        />
      )}
      <Modal icon="share" show={show} setShow={setShow} title="Link do faktury">
        <Box>
          <Input
            name="url"
            error={errors?.url}
            value={watch("url")}
            rhf={register("url", {
              required: t("required", { ns: "form" }),
            })}
            $marginBottom="S"
          />
          <Button icon="save" onClick={handleSubmit(onSubmit)} $width="100%" loading={loading}>
            Zapisz
          </Button>
        </Box>
      </Modal>
    </>
  )
}

export default TransactionInvoiceButton
